import { createActionTypes, createNoLoadActionTypes } from './utils';

export const LOAD_COMMODITY_CODES = createActionTypes('LOAD_COMMODITY_CODES');
export const UPDATE_COMMODITY_CODES = createActionTypes('UPDATE_COMMODITY_CODES');
export const SEARCH_COMMODITY_CODES = createNoLoadActionTypes('SEARCH_COMMODITY_CODES');
export const SET_COMMODITY_CODES = createNoLoadActionTypes('SET_COMMODITY_CODES');
export const SET_SELECTED_COMMODITY_CODES = createNoLoadActionTypes('SET_SELECTED_COMMODITY_CODES');
export const RESET_COMMODITY_CODES = createNoLoadActionTypes('RESET_COMMODITY_CODES');
